import { render, staticRenderFns } from "./BlockManage.vue?vue&type=template&id=3f5f4a0c&scoped=true&"
import script from "./BlockManage.vue?vue&type=script&lang=js&"
export * from "./BlockManage.vue?vue&type=script&lang=js&"
import style0 from "./BlockManage.vue?vue&type=style&index=0&id=3f5f4a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5f4a0c",
  null
  
)

export default component.exports